import styled from 'styled-components'

export const Background = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--border-main, #ededed);
  background: var(--global-white, #fff);
  padding: 15px 0px;
  position: relative;
  z-index: 999;
  @media print {
    display: none;
  }
`

export const LeftSide = styled.div`
  svg {
    cursor: pointer;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
`

export const Button = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-main, #ededed);
  background: var(--global-white, #fff);

  color: var(--primary-40, #3baab0);
  text-align: center;
  font-weight: 600;
  margin: 0px 5px;

  &:hover {
    background: #3baab0;
    color: #fff;
  }
`

export const Body = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ContainerContent = styled.div`
  max-width: 840px;
  margin: 0 auto;
  width: 100%;
`; 